'use strict';

module.exports = {
    /**
     * Get an array containing one object that DetailsItem.jsx will
     * use to render a detail. Each object will have a key 'value',
     * which holds the display name of an attribute on the item.
     *
     * @param {object} config
     * @param {object} config.item    - Bunsen Item model
     * @param {string} attributeName  - Bunsen Item model attribute you want to be the display name of a detail
     * @param {object} passedValue    - The value to use, overriding the model
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *               link: string
     *          }[]}
     */
    getSingleValueWithoutLink(config, attributeName, passedValue) {
        const contents = [];
        const item = config.item;
        const value = passedValue || item.get(attributeName);

        if (value) {
            contents.push({
                isLink: false,
                value: value,
            });
        }

        return contents;
    },

    /**
     * Get an array containing one object that DetailsItem.jsx will
     * use to render a detail. Each object will have a key 'value',
     * which holds the display name of an attribute on the item.
     *
     * @param {object} config
     * @param {object} config.model        - Bunsen Item model
     * @param {string} config.modelKey     - Bunsen Item model attribute you want to be the display name of a detail
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *          }[]}
     */
    getSingleValueFromModelWithoutLink(config) {
        const { model, modelKey } = config;
        const contents = [];
        const content = { isLink: false };

        if (model) {
            content.value = model.get(modelKey);
        }

        if (content.value) {
            contents.push(content);
        }

        return contents;
    },

    /**
     * Get an array containing one object that DetailsItem.jsx will
     * use to render a detail. Each object will have a key 'value',
     * which holds a display name either calculated elsewhere and
     * passed as a param or found on the item here.
     *
     * @param {object} config
     * @param {string} config.passedValue  - the display name for a detail
     * @param {object} config.model        - Bunsen Item model
     * @param {string} config.modelKey     - Bunsen Item model attribute you want to be the display name of a detail
     *                                       if config.passedValue is undefined
     * @param {string} config.linksKey     - the key under which links for a detail can be found in config.links
     * @param {object} config.links        - see this.detailLinks in ItemStore for definition {@link newPdp/ItemStore}
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *               link: string
     *          }[]}
     *
     */
    addToContents(config) {
        const { passedValue, model, modelKey, links, linkKey } = config;
        const contents = [];
        const content = { isLink: false };
        let link;

        if (passedValue) {
            content.value = passedValue;
        } else if (model) {
            content.value = model.get(modelKey);
        }

        if (links && links[linkKey]) {
            const value = content.value;
            link = links[linkKey][value];
        }

        if (link) {
            content.isLink = true;
            content.link = link;
        }

        if (content.value) {
            contents.push(content);
        }

        return contents;
    },
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/helpers/detailsSharedLogic.es.js